<div class="board-button">
	<button mat-button class="create-project-button" (click)="createNewProject()">
		<mat-icon *ngIf="!loadingSpinner">add</mat-icon>
		<lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
		<div class="button-title">New Project</div>
	</button>
</div>

<app-board-filter-button></app-board-filter-button>

<div style="flex: 1">

</div>

<app-columns-filter></app-columns-filter>